import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { APropos } from './pages/APropos';
import { Adherents } from './pages/Adherents';
import { Evenements } from './pages/Evenements';
import { EventDetail } from './pages/EventDetail';
import { Blog } from './pages/Blog';
import { BlogDetail } from './pages/BlogDetail';
import { GuideInvest } from './pages/GuideInvest';
import { Utilitaires } from './pages/Utilitaires';
import { Emploi } from './pages/Emploi';
import { Contact } from './pages/Contact';
export function App() {
  return <Router data-id="element-0">
      <div className="min-h-screen flex flex-col bg-white" data-id="element-1">
        <Navigation data-id="element-2" />
        <main className="flex-1" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/a-propos" element={<APropos data-id="element-8" />} data-id="element-7" />
            <Route path="/adherents" element={<Adherents data-id="element-10" />} data-id="element-9" />
            <Route path="/events" element={<Evenements data-id="element-12" />} data-id="element-11" />
            <Route path="/event-post/:slug" element={<EventDetail data-id="element-14" />} data-id="element-13" />
            <Route path="/blog" element={<Blog data-id="element-16" />} data-id="element-15" />
            <Route path="/blog-posts/:slug" element={<BlogDetail data-id="element-18" />} data-id="element-17" />
            <Route path="/ouvrir-son-restaurant" element={<GuideInvest data-id="element-20" />} data-id="element-19" />
            <Route path="/informations-utiles" element={<Utilitaires data-id="element-22" />} data-id="element-21" />
            <Route path="/career" element={<Emploi data-id="element-24" />} data-id="element-23" />
            <Route path="/contact" element={<Contact data-id="element-26" />} data-id="element-25" />
          </Routes>
        </main>
        <Footer data-id="element-27" />
      </div>
    </Router>;
}